import { useFlysiteUrls } from 'hooks/useFlysiteUrls/useFlysiteUrls';
import { useTranslations } from 'utils/translations/useTranslations';

export const RecurringTermsLink = () => {
  const { recurringTermsUrl } = useFlysiteUrls();
  const i18n = useTranslations();

  return (
    <a
      className="Link"
      href={recurringTermsUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      {i18n.t('checkout.termsAndConditions.terms_of_use.recurring')}
    </a>
  );
};
